module.exports = __webpack_public_path__ + "static/img/qrcode-business.af597a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode-business.png
// module id = MAq3
// module chunks = 0